var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React, { PureComponent } from "react";
import { perkbox } from "@irati/ui/src/global/colors";
import Flex from "@irati/ui/src/Flex";
import { Para } from "@irati/ui/src/Labels";
import { Hr } from "@irati/ui/src/Layout";
import Pill from "@irati/ui/src/Pill";
import { Chart } from "../Chart";
import { TitleWrapper, CardInnerSection, SparkStat, SparkCard as SparkCardUI } from "./styled";
var SparkCard = /** @class */ (function (_super) {
    __extends(SparkCard, _super);
    function SparkCard() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SparkCard.prototype.render = function () {
        var _a = this.props, title = _a.title, subtitle = _a.subtitle, valueLeft = _a.valueLeft, labelLeft = _a.labelLeft, valueRight = _a.valueRight, labelRight = _a.labelRight, sparkData = _a.sparkData, accentColor = _a.accentColor;
        var chartDataWithColorOverride = {
            keyX: "date",
            keyY: "value",
            values: [
                {
                    info: __assign({ color: accentColor || perkbox.blue }, sparkData.info),
                    points: __spreadArrays(sparkData.points)
                }
            ]
        };
        return (React.createElement(SparkCardUI, { flush: true },
            React.createElement(CardInnerSection, { type: "top", height: "120px" },
                React.createElement(Flex, { justifyContent: "space-between" },
                    React.createElement(Chart, { nonResponsiveChart: true, chartHeight: 80, chartWidth: 60, hideAxis: true, hideTooltip: true, data: chartDataWithColorOverride }),
                    React.createElement(TitleWrapper, null,
                        React.createElement(Para, { bold: true }, title),
                        React.createElement(Para, null, subtitle)))),
            React.createElement(Hr, { flush: true }),
            React.createElement(CardInnerSection, { type: "bottom", height: "90px" },
                React.createElement(Flex, { width: "100%", justifyContent: "space-between" },
                    React.createElement(Flex, { direction: "column" },
                        React.createElement(SparkStat, { color: accentColor }, valueLeft),
                        React.createElement(Pill, { center: true, text: labelLeft })),
                    React.createElement(Flex, { direction: "column" },
                        React.createElement(SparkStat, { color: accentColor }, valueRight),
                        React.createElement(Pill, { center: true, text: labelRight }))))));
    };
    return SparkCard;
}(PureComponent));
export default SparkCard;
